import type { SetKeyOptions } from ".";

/**
 *
 *
 */
export function checkStorage(storage?: Storage): Storage | undefined {
  if (!storage) {
    return undefined;
  }

  try {
    storage.setItem("storageTest", "test");
    storage.getItem("storageTest");
    storage.removeItem("storageTest");
    return storage;
  } catch {
    return undefined;
  }
}

const distanceQuotients = [
  ["ms", 1],
  ["s", 1000],
  ["m", 60 * 1000],
  ["h", 60 * 60 * 1000],
  ["d", 24 * 60 * 60 * 1000],
  ["y", 365.25 * 24 * 60 * 60 * 1000],
] as const;

/**
 *
 *
 *
 *
 *
 *
 */
export const computeTtl= (options: SetKeyOptions, defaults: SetKeyOptions): null | number => {
  /*                             */
  const ttlOptions = options.ttl ?? defaults.ttl;

  /*                                                                          */
  if(ttlOptions === undefined) return null

  /*                      */
  if(typeof ttlOptions === "number") return ttlOptions;
  if(ttlOptions instanceof Date) return ttlOptions.getTime()

  /*                                                                                     */
  if(typeof ttlOptions === "string") {
    const match = ttlOptions.match(/^(\d+)(ms|s|m|h|d|y)$/);
    if(!match) {
      throw new Error(`Invalid ttl string format: ${ttlOptions}`);
    }
    const [, value, unit] = match;

    /*                                */
    const quotient = distanceQuotients.find(([key]) => key === unit)?.[1] ?? 1000;
    return Date.now() + parseInt(value) * quotient;
  }

  /*                                                                                                    */
  /*                                                            */
  const ttlInMs = distanceQuotients.reduce((acc, [key, quotient]) => {
    return acc + (ttlOptions[key] ?? 0) * quotient;
  }, 0);

  /*                                                                              */
  return Date.now() + ttlInMs; 
}

export const isExprired = (ttl: null | number): boolean => {
  if(ttl === null) return false;
  return Date.now() > ttl;
}

const metadataSeparator = "|";

/**
 *
 *
 *
 *
 *
 */
export const encodeValue = (value: string, ttl: null | number): string => {
  if(ttl === null) return value;
  const meta = btoa(JSON.stringify({ ttl }));
  return `${meta}${metadataSeparator}${value}`;
}

/**
 *
 *
 *
 *
 */
export const decodeValue = (value: string | null): [string | null, null | number] => {
  if (value === null) return [value, null];
  const [meta, val] = value.split(metadataSeparator, 2);

  /*                                               */
  if(!val) return [value, null];

  try {
    /*                                                                          */
    const { ttl } = JSON.parse(atob(meta)) as { ttl: number };
    return [val, ttl];
  } catch {
    return [value, null];
  }
}
